var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"min-height":"200px"}},[(_vm.pageTitle !== false)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]):_vm._e(),_c('v-divider'),_c('v-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }